// AdminMessageService — migrated to the OpenAPI-generated client.
//
// This service spans two server controllers, which the generated spec exposes under two path
// prefixes (the client no longer hand-picks admin/ vs system/):
//   - inbox operations  -> adminBroadcastController*  (/admin/admin-message/inbox/**)
//   - send / sent mgmt  -> systemBroadcastController* (/system/admin-message/**)  <-- MOVED:
//       the pre-migration code posted these to admin/admin-message/*, but the current server
//       spec exposes send / sent / sent/{id} under /system/admin-message/*. We call the SDK
//       function for the endpoint the server actually publishes.
//   - push to trainees  -> adminTraineeMessageControllerSendNotification (/admin/message/notification)
//
// Pre-migration return shapes preserved: getters returned the raw axios `response` and callers
// read `res.data` / `res.data.count` / `res.data.id`, so we return `{data}` with the parsed
// JSON body. Auth/timezone come from configureApi's interceptor.
import {
    systemBroadcastControllerSend,
    systemBroadcastControllerListSent,
    systemBroadcastControllerDeleteSent,
    adminBroadcastControllerListInbox,
    adminBroadcastControllerUnreadCount,
    adminBroadcastControllerNextUnacknowledged,
    adminBroadcastControllerMarkRead,
    adminBroadcastControllerAcknowledge,
    adminBroadcastControllerDeleteReceipt,
    adminTraineeMessageControllerSendNotification,
} from "../api/generated";

// Re-throw the generated client's {error, response} as the axios-shaped error callers expect.
const throwAsAxiosError = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export async function sendAdminMessage(payload) {
    const {data, error, response} = await systemBroadcastControllerSend({body: payload});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function getSentAdminMessages() {
    const {data, error, response} = await systemBroadcastControllerListSent({});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function deleteSentAdminMessage(id) {
    const {data, error, response} = await systemBroadcastControllerDeleteSent({path: {id}});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function getInbox() {
    const {data, error, response} = await adminBroadcastControllerListInbox({});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function getUnreadCount() {
    const {data, error, response} = await adminBroadcastControllerUnreadCount({});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function getNextUnacknowledged() {
    const {data, error, response} = await adminBroadcastControllerNextUnacknowledged({});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function markReceiptRead(receiptId) {
    const {data, error, response} = await adminBroadcastControllerMarkRead({path: {receiptId}});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function acknowledgeReceipt(receiptId) {
    const {data, error, response} = await adminBroadcastControllerAcknowledge({path: {receiptId}});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function deleteReceipt(receiptId) {
    const {data, error, response} = await adminBroadcastControllerDeleteReceipt({path: {receiptId}});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function sendPushToTrainees(traineeIds, title, content) {
    const {data, error, response} = await adminTraineeMessageControllerSendNotification({
        body: {ids: traineeIds, title, content},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
}
